<nav class="navbar navbar-expand-lg topbar px-0">
  <div class="collapse navbar-collapse">
    <ul class="navbar-nav ms-auto">
      <li class="nav-item me-2"><a class="nav-link" [routerLink]="['/logout']"><i class="lnr lnr-exit"></i></a></li>
      <li class="nav-item v-nav-item me-2"><app-announcement-badge></app-announcement-badge></li>
      @if (!isWhiteLabelEnabled) {
        <li class="nav-item v-nav-item me-2" [popover]="helpTemplate" placement="bottom" triggers="click" [outsideClick]="true" containerClass="v-popover-apps">
          <div class="nav-link text-center"><i class="lnr lnr-question-circle"></i></div>
        </li>
      }
      <li class="nav-item v-nav-item me-2" [popover]="appsTemplate" placement="bottom" triggers="click" [outsideClick]="true" containerClass="v-popover-apps">
        <div class="nav-link text-center"><i class="lnr lnr-icons"></i></div>
      </li>
      <li class="nav-item v-nav-item"><a class="nav-link text-center" [routerLink]="['/account/information']" routerLinkActive="active"><i class="lnr lnr-user"></i></a></li>
      @if (companies?.length > 1) {
        <li class="nav-item v-nav-item company-switcher">
          <div class="btn-group" dropdown="dropdown" placement="bottom right">
            <button class="nav-link" type="button" dropdownToggle="dropdownToggle" [attr.aria-label]="'TOPBAR.ACCOUNTS.SWITCH' | translate" [title]="hiringFirm?.name">
              <span class="company-pill company-pill--switchable">
                <span class="company-picture" [style.background-image]="'url(' + hiringFirm?.logo_url + ')'" aria-hidden="true"></span>
                <span class="company-name">{{ hiringFirm?.name }}</span>
                <i class="lnr lnr-chevron-down company-chevron" aria-hidden="true"></i>
              </span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end company-menu" role="menu" *dropdownMenu="">
              <li><h6 class="dropdown-header">{{ 'TOPBAR.ACCOUNTS.SWITCH' | translate }}</h6></li>
              @for (c of companies; track c.id) {
                <li role="menuitem">
                  <button class="dropdown-item" type="button" [class.active]="c.id === hiringFirm?.id" [attr.aria-current]="c.id === hiringFirm?.id ? 'true' : null" (click)="onChangeCompanies(c.id)">
                    <img [src]="c.logo_url" width="24" height="24" alt="" /><span class="company-menu-label">{{ c.label }}</span>
                    @if (c.id === hiringFirm?.id) {
                      <i class="lnr lnr-checkmark-circle company-check" aria-hidden="true"></i>
                    }
                  </button>
                </li>
              }
            </ul>
          </div>
        </li>
      }
      @if (companies?.length === 1) {
        <li class="nav-item v-nav-item company-switcher company-switcher--static">
          <div class="nav-link" [title]="hiringFirm?.name">
            <span class="company-pill">
              <span class="company-picture" [style.background-image]="'url(' + hiringFirm?.logo_url + ')'" aria-hidden="true"></span>
              <span class="company-name">{{ hiringFirm?.name }}</span>
            </span>
          </div>
        </li>
      }
    </ul>
  </div>
</nav>
<app-announcement-sidebar></app-announcement-sidebar>
<ng-template #appsTemplate="">
  @for (a of apps; track a) {
    <div class="v-popover-apps-app d-inline-flex align-items-center" [ngClass]="{ 'v--opacity-50': a.isDisabled }" (click)="goTo(a)">
      <div class="w-100 text-center"><img class="mx-auto d-block" [src]="a.src" width="25" height="25" [alt]="a.label" />
        <div class="mt-2 text-muted small text-capitalize">{{ a.label }}</div>
      </div>
    </div>
  }
</ng-template>
<ng-template #helpTemplate="">
  <ul class="list-group list-group-flush">
    <li class="list-group-item list-group-item-action p-2"><a class="nav-link" href="https://vimeo.com/510463975" target="_blank" tooltip="password: vitay2021" container="body">{{ 'TOPBAR.HELP.DEMO_VIDEO' | translate }}</a></li>
    <li class="list-group-item list-group-item-action p-2"><a class="nav-link" href="https://vitay.io/faq/" target="_blank">FAQ</a></li>
  </ul>
</ng-template>
